import colors from "#src/utils/colors.ts";
import React from "react";

interface LineItemProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const LineItem: React.FC<LineItemProps> = ({
  children,
  className = "",
  ...props
}) => (
  <div
    className={`relative flex items-center p-0 pb-1 text-[${colors.dark}] ${className}`}
    {...props}
  >
    {children}
  </div>
);

interface LineItemLabelProps extends React.HTMLAttributes<HTMLSpanElement> {
  dark?: boolean;
  children: React.ReactNode;
}

export const LineItemLabel: React.FC<LineItemLabelProps> = ({
  dark,
  children,
  className = "",
  ...props
}) => (
  <span
    className={`flex-1 ${dark ? `text-[${colors.dark}]` : ""} ${className}`}
    {...props}
  >
    {children}
  </span>
);

interface LineItemButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const LineItemButton: React.FC<LineItemButtonProps> = ({
  children,
  className = "",
  ...props
}) => (
  <button
    className={`text-empty mt-1 mr-4 inline-block h-4 cursor-pointer border-0 bg-none p-0 leading-none ${className}`}
    {...props}
  >
    {children}
  </button>
);

interface LineItemTotalProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const LineItemTotal: React.FC<LineItemTotalProps> = ({
  children,
  className = "",
  ...props
}) => (
  <div
    className={`text-xl font-bold text-[${colors.dark}] ${className}`}
    {...props}
  >
    {children}
  </div>
);
